import { render } from "./OrgCriteriaWeightsDialog.vue?vue&type=template&id=5d3c0ce0"
import script from "./OrgCriteriaWeightsDialog.vue?vue&type=script&lang=js"
export * from "./OrgCriteriaWeightsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__